// extracted by mini-css-extract-plugin
export default {"ticket":"HSlk0","discount":"MhhUj","row":"_5hJZe","name":"fx0lC","singlePrice":"c9Oc8","price":"AEFFc","quantity":"Mxf+n","total":"Ay6rt","priceItem":"tUlYk"};